import React, { SVGProps } from "react";

const Mail = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.5468 1.875H23.7187V13.3984H9.89057C5.64776 13.3984 2.20828 16.8379 2.20828 21.0807V37.2135H39.0833V21.0807C39.0833 16.8379 35.6438 13.3984 31.401 13.3984H26.7916V9.55729H37.5468V1.875ZM23.7187 27.9948V16.4714H16.037C17.0014 17.7553 17.5729 19.3513 17.5729 21.0807V34.1406H36.0104V21.0807C36.0104 18.535 33.9467 16.4714 31.401 16.4714H26.7916V27.9948H23.7187ZM14.4999 21.0807V34.1406H5.2812V21.0807C5.2812 18.535 7.34489 16.4714 9.89057 16.4714C12.4363 16.4714 14.4999 18.535 14.4999 21.0807Z"
        fill="#FF1A4B"
      />
    </svg>
  );
};

Mail.displayName = "Mail";

export default Mail;
